"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("./styles");

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

var _utils = require("./utils");

var _Button = _interopRequireDefault(require("./Button"));

var _componentLoading = _interopRequireDefault(require("@doordash/component-loading"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _utilities = require("@doordash/utilities");

var _invariant = _interopRequireDefault(require("invariant"));

var _lodash = _interopRequireDefault(require("lodash.pickby"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconButton = function IconButton(_ref) {
  var type = _ref.type,
      iconType = _ref.iconType,
      size = _ref.size,
      onClick = _ref.onClick,
      isDisabled = _ref.isDisabled,
      isToggleable = _ref.isToggleable,
      isToggled = _ref.isToggled,
      state = _ref.state,
      id = _ref.id,
      tag = _ref.tag,
      isDepressed = _ref.isDepressed,
      href = _ref.href,
      target = _ref.target,
      accessibilityLabel = _ref.accessibilityLabel,
      accessibilityDescribedBy = _ref.accessibilityDescribedBy,
      accessibilityRole = _ref.accessibilityRole,
      onAnimationEnd = _ref.onAnimationEnd,
      isRaised = _ref.isRaised,
      props = _objectWithoutProperties(_ref, ["type", "iconType", "size", "onClick", "isDisabled", "isToggleable", "isToggled", "state", "id", "tag", "isDepressed", "href", "target", "accessibilityLabel", "accessibilityDescribedBy", "accessibilityRole", "onAnimationEnd", "isRaised"]);

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  (0, _invariant["default"])(isRaised ? type === _constants.Types.Plain || type === _constants.Types.Primary || type === _constants.Types.PrimaryPill : true, "\n      You can only use isRaised with Plain, Primary\n      or PrimaryPill type buttons.\n    ");
  (0, _invariant["default"])(type === _constants.Types.FlatPrimary || type === _constants.Types.FlatSecondary ? !isToggleable : true, "\n      Do not set isToggleable to true when type is\n      IconButton.Types.FlatPrimary or IconButton.Types.FlatSecondary.\n    ");
  (0, _invariant["default"])(typeof accessibilityLabel !== 'undefined' && typeof accessibilityLabel === 'string' && accessibilityLabel.length > 1, "\n      You must provide an accessibilityLabel to an IconButton\n      to indicate what should be used by assistive technology.\n    ");

  _react["default"].useEffect(function () {
    if (size === IconButton.Sizes.XLarge) {
      // eslint-disable-next-line no-console
      console.warn('Warning! `XLarge` IconButton Size will be removed in Prism Web v7 - we recommend changing your size to `Large`');
    }
  }, [size]);

  var propsToForward = (0, _utilities.getPropsToForward)({
    props: props,
    prefixesToForward: ['data-', 'aria-']
  });
  return /*#__PURE__*/_react["default"].createElement(_styles.ButtonRoot, _extends({
    themeColors: theme.Colors,
    themeBorderRadius: theme.BorderRadius.ButtonDefault,
    themeHeight: theme.Size[_constants.SizeSemantics[size]],
    id: id,
    isIconButton: true,
    isInline: true,
    size: size,
    isRaised: isRaised,
    onClick: isDisabled || state !== _constants.States.Default ? null : onClick,
    shape: theme.Shape.IconButtonDefault,
    as: tag,
    type: "button",
    isDepressed: isDepressed,
    isToggleable: isToggleable,
    isToggled: isToggled,
    disabled: tag === 'button' ? isDisabled : undefined,
    kind: type,
    href: href,
    target: target,
    tabIndex: tag !== 'button' ? 0 : undefined,
    "aria-label": accessibilityLabel,
    "aria-disabled": tag !== 'button' ? isDisabled : undefined,
    "aria-describedby": accessibilityDescribedBy,
    "aria-pressed": isToggleable ? isToggled : undefined,
    role: typeof accessibilityRole !== 'undefined' ? accessibilityRole : tag !== 'button' ? 'button' : undefined
  }, propsToForward), state !== _constants.States.Default ? /*#__PURE__*/_react["default"].createElement(_styles.SpinnerContainer, {
    type: type
  }, /*#__PURE__*/_react["default"].createElement(_componentLoading["default"], {
    size: _componentLoading["default"].Sizes[(0, _utils.loadingSizeForButton)(size)],
    color: _componentLoading["default"].Colors.CurrentColor,
    state: (0, _utils.loadingStateForButton)(state),
    onAnimationEnd: onAnimationEnd
  })) : /*#__PURE__*/_react["default"].createElement(_designLanguage.Icon, {
    type: iconType,
    shouldAdjustSmallSizesWhitespace: true,
    size: _designLanguage.Icon.Sizes[(0, _utils.iconSizeForIconButton)(size)],
    color: _designLanguage.Icon.Colors.CurrentColor
  }));
};

var allowedProps = function allowedProps(object) {
  return (0, _lodash["default"])(object, function (value, key) {
    return ['onClick', 'isDisabled', 'isToggleable', 'isToggled', 'state', 'id', 'tag', 'isDepressed', 'href', 'target', 'accessibilityLabel', 'accessibilityDescribedBy', 'accessibilityRole', 'onAnimationEnd'].includes(key);
  });
};

IconButton.propTypes = _objectSpread(_objectSpread({}, allowedProps(_Button["default"].propTypes)), {}, {
  size: _Button["default"].propTypes.size,
  type: _propTypes["default"].oneOf(Object.values(_constants.Types)),
  iconType: _designLanguage.Icon.propTypes.type,
  accessibilityLabel: _Button["default"].propTypes.accessibilityLabel.isRequired
});
IconButton.defaultProps = _objectSpread({
  type: _constants.Types.Plain,
  size: _Button["default"].Sizes.Medium
}, allowedProps(_Button["default"].defaultProps));
IconButton.Sizes = _Button["default"].Sizes;
IconButton.States = _Button["default"].States;
IconButton.Types = (0, _utils.omitSpecificTypes)(['Link']);
IconButton.IconTypes = _designLanguage.Icon.Types;
var _default = IconButton;
exports["default"] = _default;